<div class="file-explorer">
  <app-toolbar [noData]="!loading && backup.length === 0"></app-toolbar>
  <div class="file-explorer-container">
    <div class="file-explorer-nav">
      @for (content of backup; track content; let index = $index) {
        @if (content.details.type !== 'FILE') {
          <app-explorer-nav-row [folder]="backup[index]"></app-explorer-nav-row>
        }
      }
    </div>
    <div class='side-panel' (click)="clearSelectedContent()">
      <app-breadcrumb-panel></app-breadcrumb-panel>
      <div class="file-explorer-contents">
        <app-explorer-contents [loading]="loading" [noData]="!loading && backup.length === 0">
        </app-explorer-contents>
      </div>
    </div>
    <app-info-panel></app-info-panel>
  </div>
</div>